'use client';

import React from 'react';
import { useCookies } from 'next-client-cookies';
import ProductListProvider from 'components/commercetools-ui/organisms/product/product-list/context';
import PromotionalProductBanner, { Props } from 'components/commercetools-ui/organisms/promotional-product-banner';
import { mapCategotry } from 'helpers/entity-mappers/map-category';
import { flattenTree } from 'helpers/utils/flattenTree';
import { useWishlist } from 'frontastic/hooks';
import { TasticProps } from '../types';

const PromotionalProductBannerTastic = ({ data, categories }: TasticProps<Props>) => {
  const cookies = useCookies();
  const locale = cookies.get('locale') as string;
  const { data: wishlist, addToWishlist, removeLineItem } = useWishlist();
  const flattenedCategories = categories.flatMap((category) => flattenTree(category, 'descendants'));
  return (
    <ProductListProvider
      categories={flattenedCategories.map((category) => mapCategotry(category, { locale }))}
      facetsConfiguration={{}}
      uiState={{
        totalItems: 0,
      }}
      wishlist={wishlist}
      addToWishlist={async (lineItem, count) => {
        if (wishlist) await addToWishlist(wishlist, lineItem, count);
      }}
      removeFromWishlist={async (lineItem) => {
        if (wishlist) await removeLineItem(wishlist, lineItem);
      }}
    >
      <PromotionalProductBanner data={data} />
    </ProductListProvider>
  );
};

export default PromotionalProductBannerTastic;
